import LocaleData from "./sap/ui/core/LocaleData.js";

export default LocaleData;
